// ./http-common.ts
import axios from 'axios';
import { Const } from '../../common/constants/Constants';

// const apiUrl = 'http://localhost:8000/api/v1/';

// axios.interceptors.request.use(
//     // allowedOriginと通信するときにトークンを付与するようにする設定
//     config => {
//       const { origin } = new URL(config.url);
//       const allowedOrigins = [apiUrl];
//       const token = localStorage.getItem('token');
//       if (allowedOrigins.includes(origin)) {
//         config.headers.authorization = `Bearer ${token}`;
//       }
//       return config;
//     },
//     error => {
//       return Promise.reject(error);
//     }
//   );

const intorceptor = axios.create({
  //開発環境用
  // baseURL: 'http://' + window.location.hostname + ':8080/',
  //本番用
  baseURL: 'https://' + window.location.hostname + '/API',

  headers: {
    'Content-type': 'application/json',
    // ヘッダーに認証用のJWTを付与
    Authorization: 'Bearer ' + sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.JWT),
  },
});

// バックエンドに送信する際に必ず実行される処理
intorceptor.interceptors.request.use((request) => {
  // ヘッダーに認証用JWTを付与
  const jwt = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.JWT);
  if (jwt !== '') {
    request.headers = { Authorization: 'Bearer ' + jwt };
  }
  return request;
});

// バックエンドから受信する際に必ず実行される処理
intorceptor.interceptors.response.use(
  // 受信成功時
  (response) => {
    // 受信内容をそのまま通過
    return response; // 第一引数は通信成功時処理。受けた内容をそのまま通過
  },
  // 受信エラー時（バックエンドでエラー送信）
  async (error) => {
    // 401（認証エラー）のとき、またはresponseがundefinedのとき(不具合管理表No74)、ログイン画面に遷移
    if (error.response === undefined || error.response.status === 401) {
      // responseがundefinedの場合があるため、responseをログに出力
      console.log('response error - response:' + error.response);
      window.location.href = '/login';
    }
    console.log('response error - status:' + error.response.status);
    // エラー内容をそのまま通過
    return Promise.reject(error);
  }
);

export default intorceptor;
